import { createVNode as i, mergeProps as n } from "vue";
import f from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ArrowLeftOutlined.js";
import l from "../components/PfIcon.js";
const r = (t, e) => {
  const o = {
    ...t,
    ...e.attrs
  };
  return i(l, n(o, {
    icon: f
  }), null);
};
r.displayName = "ArrowLeftOutlined";
r.inheritAttrs = !1;
export {
  r as default
};
